import Page from "components/common/page/Page";
import SeasonForm from "components/entities/app/season/SeasonForm";
import { GraphResponse } from "config/axios-context";
import { AppRoutes } from "config/router";
import { useParams } from "react-router-dom";
import { SaveSeasonMutationMutation } from "types/graphql";
import { SeasonType } from "types/season-type";
import useAppNavigate from "utilities/hooks/useAppNavigate";

type SeasonFormPageUrlParamsType = {
    id?: string
}

const SeasonFormPage = () => {
    const params = useParams<SeasonFormPageUrlParamsType>();
    const navigate = useAppNavigate();

    const onSubmit = (model: SeasonType | undefined, response: GraphResponse<SaveSeasonMutationMutation>) => {
        if(response.success) navigate(AppRoutes.SEASON_VIEW, {id: model!.id });
    }

    return (
        <Page title="pages.season.form">
            <SeasonForm onSubmit={onSubmit} name="season-form-page" formId="season-form-page" model={params?.id} />
        </Page>
    )
}
export default SeasonFormPage;
